import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';
import { Criteria } from '../../interfaces/criteria';

export interface CriteriasQueryResponse {
  criterias: {
    code: string;
    success: boolean;
    message: string;
    criteria: Criteria[];
  };
}

export interface CountQueryResponse {
  countCriteria: {
    code: string;
    success: boolean;
    message: string;
    count: number;
  };
}

export interface CriteriaWhere {
  accountUid: string;
  accessoryUid?: string;
  feeUid?: string;
  fiAddOnUid?: string;
  bodyStyleUid?: string;
  type?: string;
}

export interface CriteriasParams {
  where: CriteriaWhere;
  limit: number;
  offset: number;
  sortDirection: 'ASC' | 'DESC';
}

@Injectable({
  providedIn: 'root',
})
export class CriteriasGQL extends Query<CriteriasQueryResponse, CriteriasParams> {
  document = gql(`
  query criterias($where: ModelCriteriaFilterInput, $limit: Int, $offset: Int, $sortDirection: ModelSortDirection) {
    criterias(where: $where, limit: $limit, offset: $offset, sortDirection: $sortDirection) {
      code
      success
      message
      criteria {
        uid
        accessoryUid
        accessory {
          uid
          title
          price
        }
        feeUid
        fee {
          uid
          title
          amount
          amount_type
        }
        fiAddOnUid
        fiAddOn {
          uid
          title
          price
        }
        operator
        for_vehicle
        for_product
        vehicle_condition
        deal_type
        origin
        type
        city
        county
        state
        fuel_type
        input_name
        input_name_normalized
        vehicleBodyStyles {
          criteriaUid
          bodyStyleUid
          bodyStyle {
            body
          }
        }
        vehicleMakes {
          criteriaUid
          make_id
          make {
            name
          }
        }
        vehicleModels {
          criteriaUid
          model_id
          model {
            name
            year
          }
        }
        vehicleYears {
          criteriaUid
          year
        }
        productExclusions {
          criteriaUid
          exclusionUid
          product {
            title
            price
          }
        }
      }
    }
  }
  `);
}

export interface GetCriteriaQueryResponse {
  criteria: {
    code: String;
    success: Boolean;
    message: String;
    criteria: Criteria;
  };
}

@Injectable({
  providedIn: 'root',
})
export class GetCriteriaGQL extends Query<GetCriteriaQueryResponse, { uid: string }> {
  document = gql(`
  query criteria($uid: ID!) {
    criteria(uid: $uid) {
      code
      success
      message
      criteria {
        uid
        accessoryUid
        feeUid
        fiAddOnUid
        bodyStyleUid
        operator
        for_vehicle
        for_product
        vehicle_condition
        deal_type
        origin
        type
        city
        county
        state
        fuel_type
        input_name
        input_name_normalized
        vehicleBodyStyles {
          criteriaUid
          bodyStyleUid
          bodyStyle {
            body
          }
        }
        vehicleMakes {
          criteriaUid
          make_id
          make {
            name
          }
        }
        vehicleModels {
          criteriaUid
          model_id
          model {
            name
          }
        }
        vehicleYears {
          criteriaUid
          year
        }
        productExclusions {
          criteriaUid
          exclusionUid
          product {
            title
          }
        }
      }
    }
  }
  `);
}

export interface CountCriteriaParams {
  where: CriteriaWhere;
}

@Injectable({
  providedIn: 'root',
})
export class CountCriteriaGQL extends Query<CountQueryResponse, CountCriteriaParams> {
  document = gql(`
  query countCriteria($where: ModelCriteriaFilterInput) {
    countCriteria(where: $where) {
      code
      success
      message
      count
    }
  }
  `);
}
